import renegades from './renegades.mjs'
import renegadeslrk from './renegadeslrk.mjs'
import classics3 from './classics3.mjs'
import classics3lrk from './classics3lrk.mjs'
import classics4 from './classics4.mjs'
import classics4lrk from './classics4lrk.mjs'
import classics4pro from './classics4pro.mjs'
import classics4prolrk from './classics4prolrk.mjs'
import sierras from './sierras.mjs'
import sierraslrk from './sierraslrk.mjs'
import tempests from './tempests.mjs'
import tempestslrk from './tempestslrk.mjs'
import zephyrs from './zephyrs.mjs'
import zephyrslrk from './zephyrslrk.mjs'
import airas from './airas.mjs'
import airaslrk from './airaslrk.mjs'
import airasck from './airasck.mjs'
import vulcans from './vulcans.mjs'
import vulcansvent from './vulcansvent.mjs'
import vulcanslrk from './vulcanslrk.mjs'
import vulcansventlrk from './vulcansventlrk.mjs'
import vulcansck from './vulcansck.mjs'
import velans from './velans.mjs'
import velans2 from './velans2.mjs'
import velanslrk from './velanslrk.mjs'
import velans2lrk from './velans2lrk.mjs'
import velansck from './velansck.mjs'
import ultras from './ultras.mjs'
import ultrasair from './ultrasair.mjs'
import ultraslrk from './ultraslrk.mjs'
import ultrasairlrk from './ultrasairlrk.mjs'
import forty2s from './forty2s.mjs'
import forty2slrk from './forty2slrk.mjs'
import ullrs from './ullrs.mjs'
import ullrsparts from './ullrsparts.mjs'
import ullrsLeChaos27 from './ullrs-le_chaos27.mjs'
import vanguards from './vanguards.mjs'
import vanguardsparts from './vanguardsparts.mjs'
import snipers from './snipers.mjs'
import snipersparts from './snipersparts.mjs'
import earsocksrk from './earsocksrk.mjs'
import classics3leRFU22 from './classics3-le_rfu22.mjs'
import classics3leDR3 from './classics3-le_dr3.mjs'
import classics3leAirton from './classics3-le_airton.mjs'
import classics3leSAS from './classics3-le_sas.mjs'
import renegadesleMcLaren from './renegades-le_mclaren.mjs'
import renegadesleMcLarenPlus from './renegades-le_mclarenplus.mjs'
import renegadesleWoodsy from './renegades-le_woodsy.mjs'
import renegadesleMcLarenMiami from './renegades-le_mclarenmiami.mjs'
import renegadesleMcLarenMiami23 from './renegades-le_mclarenmiami23.mjs'
import renegadesleSAS from './renegades-le_sas.mjs'
import sierrasleKatieO from './sierras-le_katieo.mjs'
import sierrasleLN4 from './sierras-le_ln4.mjs'
import sierrasleMcLaren from './sierras-le_mclaren.mjs'
import sierrasleMcLarenPlus from './sierras-le_mclarenplus.mjs'
import sierrasleMcLarenMonaco from './sierras-le_monaco.mjs'
import sierrasleSailGP from './sierras-le_sailgp.mjs'
import sierrasleSAS from './sierras-le_sas.mjs'
import sierrasleIneosBritannia from './sierras-le_ineosbritannia.mjs'
import tempestsleDR3 from './tempests-le_dr3.mjs'
import tempestsleMcLarenMX from './tempests-le_mclarenmx.mjs'
import tempestsleSailGP from './tempests-le_sailgp.mjs'
import tempestsleIneosBritannia from './tempests-le_ineosbritannia.mjs'
import airasleWiV from './airas-le_wiv.mjs'
import zephyrsleLN4 from './zephyrs-le_ln4.mjs'
import zephyrsleLN4clear from './zephyrs-le_ln4clear.mjs'
import zephyrsleMonaco23 from './zephyrs-le_monaco23.mjs'
import vulcansLeMomentum from './vulcans-le_momentum.mjs'
import velansLeMomentum from './velans-le_momentum.mjs'
import vulcansLeTekkerz from './vulcans-le_tekkerz.mjs'
import vulcansLeIneos from './vulcans-le_ineosgrenadiers.mjs'
import velansLeIneos from './velans-le_ineosgrenadiers.mjs'
import airasLeIneos from './airas-le_ineosgrenadiers.mjs'
import velansLeTomPidcock from './velans-le_tompidcock.mjs'
import tempestsLeMcLarenPlus from './tempests-le_mclarenplus.mjs'
import zephyrsLeAirton from './zephyrs-le_airton.mjs'
import tokas from './tokas.mjs'
import tokaslrk from './tokaslrk.mjs'
import zephyrsLeSilverstone from './zephyrs-le_silverstone.mjs'
import ultrasLeTomEvans from './ultras-le_tomevans.mjs'
import tokasLeMcLaren60th from './tokas-le_mclaren60th.mjs'
import vulcansLePauline from './vulcans-le_pauline.mjs'
import ultrasLeHayden from './ultras-le_hayden.mjs'
import renegadesLeMcLaren24 from './renegades-le_mclaren24.mjs'
import sierrasLeMcLaren24 from './sierras-le_mclaren24.mjs'
import zephyrsLeMcLaren24 from './zephyrs-le_mclaren24.mjs'
import vulcansLeMcLaren24 from './vulcans-le_mclaren24.mjs'
import sierrasLeMcLaren24Monaco from './sierras-le_mclaren24monaco.mjs'
import gts from './gts.mjs'
import gtslrk from './gtslrk.mjs'
import zephyrsLeSolstice from './zephyrs-le_solstice.mjs'
import tokasLeSolstice from './tokas-le_solstice.mjs'
import classics4LeWilliams from './classics4-le_williams.mjs'
import renegadesLeWlliams from './renegades-le_williams.mjs'
import classics4LePadres from './classics4-le_padres.mjs'
import classics4LePadresCC from './classics4-le_padrescc.mjs'
import renegadesLePadres from './renegades-le_padres.mjs'
import vulcansLePadres from './vulcans-le_padres.mjs'
import vulcansLePadresCC from './vulcans-le_padrescc.mjs'
import zephyrsLePadres from './zephyrs-le_padres.mjs'
import classics4LeCourtney from './classics4-le_courtney.mjs'
import miras from './miras.mjs'
import miraslrk from './miraslrk.mjs'
import mirasLeGrape from './miras-le_grape.mjs'
import mirasLeECB from './miras-le_ecb.mjs'
import renegadesLeECB from './renegades-le_ecb.mjs'
import renegadesLeAstros from './renegades-le_astros.mjs'
import renegadesLeDodgers from './renegades-le_dodgers.mjs'
import renegadesLeGiants from './renegades-le_giants.mjs'
import renegadesLeRedsox from './renegades-le_redsox.mjs'
import renegadesLeYankees from './renegades-le_yankees.mjs'
import zephyrsLeAstros from './zephyrs-le_astros.mjs'
import zephyrsLeDodgers from './zephyrs-le_dodgers.mjs'
import zephyrsLeGiants from './zephyrs-le_giants.mjs'
import zephyrsLeRedsox from './zephyrs-le_redsox.mjs'
import zephyrsLeYankees from './zephyrs-le_yankees.mjs'
import zephyrsLeMclaren24lasvegas from './zephyrs-le_mclaren24lasvegas.mjs'
import renegadesLeOP81 from './renegades-le_op81.mjs'
import mirasLe_mclaren25 from './miras-le_mclaren25.mjs'
import mirasLe_mclaren25Miami from './miras-le_mclaren25-miami.mjs'
import renegadesLe_mclaren25 from './renegades-le_mclaren25.mjs'
import renegadesLe_mclaren25Plus from './renegades-le_mclaren25-plus.mjs'
import vulcansLe_mclaren25 from './vulcans-le_mclaren25.mjs'
import zephyrsLe_ln425 from './zephyrs-le_ln4-25.mjs'
import zephyrsLe_ln4Neon from './zephyrs-le_ln4-neon.mjs'
import zephyrsLe_ln4Silverstone from './zephyrs-le_ln4-silverstone.mjs'
import zephyrsLe_mclaren25 from './zephyrs-le_mclaren25.mjs'
import zephyrsLeNewEra from './zephyrs-le_newera.mjs'
import classics4LeNewEra from './classics4-le_newera.mjs'
import classics4LeCourtney25 from './classics4-le_courtney25.mjs'
import classics4LeCourtneyCore25 from './classics4-le_courtneycore25.mjs'
import vulcansLeINEOS25 from './vulcans-le_ineosgrenadiers25.mjs'
import vulcansLeINEOS25TDF from './vulcans-le_ineosgrenadiers25-tdf.mjs'
import vulcansLeINEOS26FF from './vulcans-le_ineosgrenadiers26-ff.mjs'
import vulcansLeINEOS26HF from './vulcans-le_ineosgrenadiers26-hf.mjs'
import vulcansLeINEOS26Vent from './vulcans-le_ineosgrenadiers26-vent.mjs'
import forty2sLeNeon from './forty2s-le_neon.mjs'
import sierrasLe8desertsand from './sierras-le_8desertsand.mjs'
import sierrasLe8Pdesertsand from './sierras-le_8Pdesertsand.mjs'
import tokasLe8desertsand from './tokas-le_8desertsand.mjs'
import tokasLe8Pdesertsand from './tokas-le_8Pdesertsand.mjs'
import ultrasLeDesertsand from './ultras-le_desertsand.mjs'
import velansLeDesertsand from './velans-le_desertsand.mjs'
import sierrasLe8vanta from './sierras-le_8vanta.mjs'
import sierrasLe8Pvanta from './sierras-le_8Pvanta.mjs'
import airasLe8vanta from './airas-le_8vanta.mjs'
import renegadesLe8vanta from './renegades-le_8vanta.mjs'
import renegadesLe8Pvanta from './renegades-le_8Pvanta.mjs'
import tokasLe8Brick from './tokas-le_8londonbrick.mjs'
import zephyrsLe8Brick from './zephyrs-le_8londonbrick.mjs'
import vulcansLe8Brick from './vulcans-le_8londonbrick.mjs'
import forty2sLe_mclaren26Papaya from './forty2s-le_mclaren26-papaya.mjs'
import mirasLe_mclaren26 from './miras-le_mclaren26.mjs'
import mirasLe_mclaren26Tortoise from './miras-le_mclaren26-tortoise.mjs'
import mirasLe_mclaren26Vegas from './miras-le_mclaren26-vegas.mjs'
import renegadesLe_mclaren26 from './renegades-le_mclaren26.mjs'
import renegadesLe_mclaren26Papaya from './renegades-le_mclaren26-papaya.mjs'
import renegadesLe_mclaren26Plus from './renegades-le_mclaren26-plus.mjs'
import renegadesLe_op8126 from './renegades-le_op81-26.mjs'
import renegadesLe_op81Melbourne26 from './renegades-le_op81-melbourne26.mjs'
import sierrasLe_mclaren26 from './sierras-le_mclaren26.mjs'
import sierrasLe_mclaren26Papaya from './sierras-le_mclaren26-papaya.mjs'
import tokasLe_mclaren26Monaco from './tokas-le_mclaren26-monaco.mjs'
import tokasLe_mclaren26Tortoise from './tokas-le_mclaren26-tortoise.mjs'
import zephyrsLe_ln1_26 from './zephyrs-le_ln1-26.mjs'
import zephyrsLe_ln1Neon26 from './zephyrs-le_ln1-neon26.mjs'
import zephyrsLe_mclaren26Silverstone from './zephyrs-le_mclaren26-silverstone.mjs'
import tokasLe_mclaren261000thgp from './tokas-le_mclaren26-1000thgp.mjs'
import forty2sLe_chelseasodaro from './forty2s-le_chelseasodaro.mjs'
import zephyrsLe_ineos26 from './zephyrs-le_ineos26.mjs'
import velans2Le_ineos26 from './velans2-le_ineos26.mjs'
import classics4proLe_courtney26 from './classics4pro-le_courtney26.mjs'
import mirasLe_rockets26 from './miras-le_rockets26.mjs'
import velans2Le_sdworx26 from './velans2-le_sdworx26.mjs'
import velans2Le_rockets26 from './velans2-le_rockets26.mjs'
import ultrasLeEilish26 from './ultras-le_eilish26.mjs'

const allLayerTemplates = {
  renegades,
  renegadeslrk,
  classics3,
  classics3lrk,
  classics4,
  classics4lrk,
  classics4pro,
  classics4prolrk,
  sierras,
  sierraslrk,
  tempests,
  tempestslrk,
  zephyrs,
  zephyrslrk,
  airas,
  airaslrk,
  airasck,
  vulcans,
  vulcansvent,
  vulcanslrk,
  vulcansventlrk,
  vulcansck,
  velans,
  velanslrk,
  velansck,
  velans2,
  velans2lrk,
  ultras,
  ultrasair,
  ultraslrk,
  ultrasairlrk,
  tokas,
  tokaslrk,
  gts,
  gtslrk,
  miras,
  miraslrk,
  forty2s,
  forty2slrk,
  ullrs,
  ullrsparts,
  vanguards,
  vanguardsparts,
  snipers,
  snipersparts,
  earsocksrk,
  'classics3-le_rfu22': classics3leRFU22,
  'classics3-le_dr3': classics3leDR3,
  'classics3-le_airton': classics3leAirton,
  'classics3-le_sas': classics3leSAS,
  'renegades-le_mclaren': renegadesleMcLaren,
  'renegades-le_mclarenplus': renegadesleMcLarenPlus,
  'renegades-le_mclarenmiami': renegadesleMcLarenMiami,
  'renegades-le_mclarenmiami23': renegadesleMcLarenMiami23,
  'renegades-le_woodsy': renegadesleWoodsy,
  'renegades-le_sas': renegadesleSAS,
  'sierras-le_katieo': sierrasleKatieO,
  'sierras-le_ln4': sierrasleLN4,
  'sierras-le_mclaren': sierrasleMcLaren,
  'sierras-le_mclarenplus': sierrasleMcLarenPlus,
  'sierras-le_mclarenmonaco': sierrasleMcLarenMonaco,
  'sierras-le_sailgp': sierrasleSailGP,
  'sierras-le_sas': sierrasleSAS,
  'sierras-le_ineosbritannia': sierrasleIneosBritannia,
  'tempests-le_dr3': tempestsleDR3,
  'tempests-le_mclarenmx': tempestsleMcLarenMX,
  'tempests-le_sailgp': tempestsleSailGP,
  'tempests-le_ineosbritannia': tempestsleIneosBritannia,
  'airas-le_wiv': airasleWiV,
  'zephyrs-le_ln4': zephyrsleLN4,
  'zephyrs-le_ln4clear': zephyrsleLN4clear,
  'zephyrs-le_monaco23': zephyrsleMonaco23,
  'velans-le_momentum': velansLeMomentum,
  'vulcans-le_momentum': vulcansLeMomentum,
  'vulcans-le_tekkerz': vulcansLeTekkerz,
  'vulcans-le_ineosgrenadiers': vulcansLeIneos,
  'velans-le_ineosgrenadiers': velansLeIneos,
  'airas-le_ineosgrenadiers': airasLeIneos,
  'velans-le_tompidcock': velansLeTomPidcock,
  'tempests-le_mclarenplus': tempestsLeMcLarenPlus,
  'zephyrs-le_airton': zephyrsLeAirton,
  'zephyrs-le_silverstone': zephyrsLeSilverstone,
  'ultras-le_tomevans': ultrasLeTomEvans,
  'ultras-le_tomevans25': ultrasLeTomEvans,
  'ultras-le_eilish26': ultrasLeEilish26,
  'tokas-le_mclaren60th': tokasLeMcLaren60th,
  'vulcans-le_pauline': vulcansLePauline,
  'ultras-le_hayden': ultrasLeHayden,
  'ultras-le_hayden25': ultrasLeHayden,
  'renegades-le_mclaren24': renegadesLeMcLaren24,
  'sierras-le_mclaren24': sierrasLeMcLaren24,
  'sierras-le_mclaren24monaco': sierrasLeMcLaren24Monaco,
  'zephyrs-le_mclaren24': zephyrsLeMcLaren24,
  'vulcans-le_mclaren24': vulcansLeMcLaren24,
  'zephyrs-le_solstice': zephyrsLeSolstice,
  'tokas-le_solstice': tokasLeSolstice,
  'classics4-le_williams': classics4LeWilliams,
  'renegades-le_williams': renegadesLeWlliams,
  'classics4-le_padres': classics4LePadres,
  'classics4-le_padrescc': classics4LePadresCC,
  'renegades-le_padres': renegadesLePadres,
  'vulcans-le_padres': vulcansLePadres,
  'vulcans-le_padrescc': vulcansLePadresCC,
  'zephyrs-le_padres': zephyrsLePadres,
  'classics4-le_courtney': classics4LeCourtney,
  'miras-le_grape': mirasLeGrape,
  'miras-le_ecb': mirasLeECB,
  'miras-le_ecb25': mirasLeECB,
  'renegades-le_ecb': renegadesLeECB,
  'renegades-le_ecb25': renegadesLeECB,
  'renegades-le_astros': renegadesLeAstros,
  'renegades-le_dodgers': renegadesLeDodgers,
  'renegades-le_giants': renegadesLeGiants,
  'renegades-le_redsox': renegadesLeRedsox,
  'renegades-le_yankees': renegadesLeYankees,
  'zephyrs-le_astros': zephyrsLeAstros,
  'zephyrs-le_dodgers': zephyrsLeDodgers,
  'zephyrs-le_giants': zephyrsLeGiants,
  'zephyrs-le_redsox': zephyrsLeRedsox,
  'zephyrs-le_yankees': zephyrsLeYankees,
  'zephyrs-le_mclaren24lasvegas': zephyrsLeMclaren24lasvegas,
  'renegades-le_op81': renegadesLeOP81,
  'miras-le_mclaren25': mirasLe_mclaren25,
  'miras-le_mclaren25-miami': mirasLe_mclaren25Miami,
  'renegades-le_mclaren25': renegadesLe_mclaren25,
  'renegades-le_mclaren25-plus': renegadesLe_mclaren25Plus,
  'vulcans-le_mclaren25': vulcansLe_mclaren25,
  'zephyrs-le_ln4-25': zephyrsLe_ln425,
  'zephyrs-le_ln4-neon': zephyrsLe_ln4Neon,
  'zephyrs-le_ln4-silverstone': zephyrsLe_ln4Silverstone,
  'zephyrs-le_mclaren25': zephyrsLe_mclaren25,
  'zephyrs-le_newera': zephyrsLeNewEra,
  'classics4-le_newera': classics4LeNewEra,
  'classics4-le_courtney25': classics4LeCourtney25,
  'classics4-le_courtneycore25': classics4LeCourtneyCore25,
  'vulcans-le_ineosgrenadiers25': vulcansLeINEOS25,
  'vulcans-le_ineosgrenadiers25-tdf': vulcansLeINEOS25TDF,
  'vulcans-le_ineosgrenadiers26-ff': vulcansLeINEOS26FF,
  'vulcans-le_ineosgrenadiers26-hf': vulcansLeINEOS26HF,
  'vulcans-le_ineosgrenadiers26-vent': vulcansLeINEOS26Vent,
  'forty2s-le_neon': forty2sLeNeon,
  'sierras-le_8desertsand': sierrasLe8desertsand,
  'sierras-le_8Pdesertsand': sierrasLe8Pdesertsand,
  'tokas-le_8desertsand': tokasLe8desertsand,
  'tokas-le_8Pdesertsand': tokasLe8Pdesertsand,
  'ultras-le_desertsand': ultrasLeDesertsand,
  'velans-le_desertsand': velansLeDesertsand,
  'sierras-le_8tripleblack': sierrasLe8vanta,
  'sierras-le_8Ptripleblack': sierrasLe8Pvanta,
  'airas-le_tripleblack': airasLe8vanta,
  'renegades-le_8tripleblack': renegadesLe8vanta,
  'renegades-le_8Ptripleblack': renegadesLe8Pvanta,
  'tokas-le_8londonbrick': tokasLe8Brick,
  'tokas-le_8Plondonbrick': tokasLe8Brick,
  'zephyrs-le_8londonbrick': zephyrsLe8Brick,
  'zephyrs-le_8Plondonbrick': zephyrsLe8Brick,
  'vulcans-le_8londonbrick': vulcansLe8Brick,
  'forty2s-le_mclaren26-papaya': forty2sLe_mclaren26Papaya,
  'miras-le_mclaren26': mirasLe_mclaren26,
  'miras-le_mclaren26-tortoise': mirasLe_mclaren26Tortoise,
  'miras-le_mclaren26-vegas': mirasLe_mclaren26Vegas,
  'renegades-le_mclaren26': renegadesLe_mclaren26,
  'renegades-le_mclaren26-papaya': renegadesLe_mclaren26Papaya,
  'renegades-le_mclaren26-plus': renegadesLe_mclaren26Plus,
  'renegades-le_op81-26': renegadesLe_op8126,
  'renegades-le_op81-melbourne26': renegadesLe_op81Melbourne26,
  'sierras-le_mclaren26': sierrasLe_mclaren26,
  'sierras-le_mclaren26-papaya': sierrasLe_mclaren26Papaya,
  'tokas-le_mclaren26-monaco': tokasLe_mclaren26Monaco,
  'tokas-le_mclaren26-tortoise': tokasLe_mclaren26Tortoise,
  'tokas-le_mclaren26-1000thgp': tokasLe_mclaren261000thgp,
  'zephyrs-le_ln1-26': zephyrsLe_ln1_26,
  'zephyrs-le_ln1-neon26': zephyrsLe_ln1Neon26,
  'zephyrs-le_mclaren26-silverstone': zephyrsLe_mclaren26Silverstone,
  'forty2s-le_chelseasodaro': forty2sLe_chelseasodaro,
  'zephyrs-le_ineos26': zephyrsLe_ineos26,
  'velans2-le_ineos26': velans2Le_ineos26,
  'classics4pro-le_courtney26': classics4proLe_courtney26,
  'miras-le_rockets26': mirasLe_rockets26,
  'velans2-le_sdworx26': velans2Le_sdworx26,
  'velans2-le_rockets26': velans2Le_rockets26,
  'ullrs-le_chaos27': ullrsLeChaos27,
}

export function getLayerTemplate(baseSKU) {
  return allLayerTemplates[baseSKU]
}

export function hasLayerTemplate(baseSKU) {
  return !!allLayerTemplates[baseSKU]
}

export default allLayerTemplates
